// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import {
    useShipmentHistoryDebouncedUpdateDraftParameter,
    useShipmentHistoryState,
} from "@store/Framework/Store/Greif/Pages/ShipmentHistory/ShipmentHistoryHooks";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC, useEffect, useMemo, useState } from "react";

export interface ShipmentHistoryFilterFieldOrderNumberProps {}

export interface ShipmentHistoryFilterFieldOrderNumberStyles {
    textField?: TextFieldPresentationProps;
}

export const shipmentHistoryFilterFieldOrderNumberStyles: ShipmentHistoryFilterFieldOrderNumberStyles = {
    textField: filterDrawerProps.textField,
};

const styles = shipmentHistoryFilterFieldOrderNumberStyles;

const ShipmentHistoryFilterFieldOrderNumber: FC<ShipmentHistoryFilterFieldOrderNumberProps> = () => {
    const { greifOrderNumber } = useShipmentHistoryState().draftParameter;
    const debouncedUpdateDraftParameter = useShipmentHistoryDebouncedUpdateDraftParameter();
    const [value, setValue] = useState(greifOrderNumber);
    const id = useMemo(uniqueId, []);

    useEffect(() => {
        if (value !== greifOrderNumber) {
            setValue(greifOrderNumber);
        }
    }, [greifOrderNumber]);

    const label = translate("Greif Order #");

    return (
        <FilterDrawerSection title={label} labelFor={id}>
            <TextField
                {...styles.textField}
                data-test-selector="shipmentHistory_orderNumberFilter"
                id={id}
                onChange={event => {
                    setValue(event.currentTarget.value);
                    debouncedUpdateDraftParameter({ greifOrderNumber: event.currentTarget.value });
                }}
                placeholder={translate("Enter {0}", label)}
                value={value}
            />
        </FilterDrawerSection>
    );
};

export default ShipmentHistoryFilterFieldOrderNumber;
